export const reservedRoutes = {
  'delete-account': true,
  delete_account: true,
  faqs: true,
  'forgot-password': true,
  forgotpassword: true,
  redeem: true,
  terms: true,
  'upgrade-membership-error': true,
  upgrade_membership_error: true,
  userfaqs: true,
  'verify-email': true,
  verify_email: true,
  waiver: true,
}
